import axios from 'axios'
import router from '../../router'

const state = {
  adminMenus: []
}

const getters = {
  getAdminMenus (state) {
    return state.adminMenus
  }
}

const mutations = {
  setAdminMenus (state, payload) {
    state.adminMenus = payload
  }
}

const actions = {
  apiSysadminMenus (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      if (payload.method === 'POST') {
        axios.post('/api/sysadmin/Menus', payload)
          .then((response) => {
            alert('저장되었습니다.')
            context.dispatch('apiSysadminMenus', {method: 'GET'})
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeouten')
            }
          })
      } else if (payload.method === 'PATCH') {
        axios.patch('/api/sysadmin/Menus/' + payload.id, payload)
          .then((response) => {
            alert('저장되었습니다.')
            context.dispatch('apiSysadminMenus', {method: 'GET'})
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else { // GET method
        axios.get('/api/sysadmin/Menus')
          .then((response) => {
            context.commit('setAdminMenus', response.data)
            context.dispatch('apiCommonsStatus')
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      }
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/sessiontimeout')
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/adminmenu.js